export default __webpack_public_path__ + "static/media/ido-usdt.9a73f1f0.svg";